import { useState, useEffect } from "react";
import { onSnapshot, doc } from "firebase/firestore";
import { db } from "../../firebase/FirebaseConfig";

export function useNameWheelData() {
  const [onceThru, setOnceThru] = useState<string[]>([]);
  const [albums, setAlbums] = useState<string[]>([]);
  const [songs, setSongs] = useState<string[]>([]);

  useEffect(() => {
    const unsubAlbums = onSnapshot(
      doc(db, "nameWheel", "Albums"),
      (docSnap) => {
        if (docSnap.exists()) {
          setAlbums(docSnap.data().names || []);
        }
      }
    );

    const unsubSongs = onSnapshot(doc(db, "nameWheel", "Songs"), (docSnap) => {
      if (docSnap.exists()) {
        setSongs(docSnap.data().names || []);
      }
    });

    const unsubOnceThru = onSnapshot(
      doc(db, "nameWheel", "OnceThrough"),
      (docSnap) => {
        if (docSnap.exists()) {
          setOnceThru(docSnap.data().names || []);
        }
      }
    );

    return () => {
      unsubAlbums();
      unsubSongs();
      unsubOnceThru();
    };
  }, []);

  return { onceThru, albums, songs };
}
